import { render } from "./RetencionList.vue?vue&type=template&id=ed34ae7e&scoped=true"
import script from "./RetencionList.vue?vue&type=script&lang=js"
export * from "./RetencionList.vue?vue&type=script&lang=js"

import "./RetencionList.vue?vue&type=style&index=0&id=ed34ae7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed34ae7e"]])

export default __exports__